import RoundedButton from '../buttons/RoundedButton';

interface CallToActionProps extends CallToAction {
    external?: boolean;
    className?: string | null;
}

function CallToAction({
    type = 'button',
    label = null,
    url = null,
    external = false,
    className = null,
}: CallToActionProps) {
    if (type === 'button') {
        return (
            <RoundedButton href={url} external={external} compact className={className}>
                {label}
            </RoundedButton>
        );
    }

    return null;
}

export default CallToAction;
